window.submitApplicationForm = function(formData) {
  // console.log(formData);
  $.ajax({
    url: "https://jsonplaceholder.typicode.com/posts",
    type: "POST",
    dataType: "JSON",
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    },
    data: JSON.stringify({}),
    success: function(data) {
      //console.log(data);
      ApplicationForm.completeForm(true);
    },
    error: function(err) {
      //console.log("hata", err);
      ApplicationForm.completeForm(false);
    }
  });
};

window.submitContactForm = function(formData) {
  // console.log(formData);
  $.ajax({
    url: "https://jsonplaceholder.typicode.com/posts",
    type: "POST",
    dataType: "JSON",
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    },
    data: JSON.stringify({}),
    success: function(data) {
      //console.log(data);
      ContactForm.completeForm(true);
    },
    error: function(err) {
      //console.log("hata", err);
      ContactForm.completeForm(false);
    }
  });
};

window.submitNewsletterForm = function(email) {
  //console.log(email);
  $.ajax({
    url: "https://jsonplaceholder.typicode.com/posts",
    type: "POST",
    dataType: "JSON",
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    },
    data: JSON.stringify({}),
    success: function(data) {
      //console.log(data);
      NewsletterForm.completeForm(true);
    },
    error: function(err) {
      //console.log("hata", err);
      NewsletterForm.completeForm(false);
    }
  });
};

window.generalSearchOnChange = function(query) {
  // console.log(query);

  return $.ajax({
    url: "https://jsonplaceholder.typicode.com/posts",
    type: "POST",
    dataType: "JSON",
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    },
    data: JSON.stringify({}),
    success: function(data) {
      //console.log(data);

      var data = [];
      for (var i = 0; i < 20; i++) {
        data.push(
          {
            link: "#",
            title: "title",
            theme: "theme",
            type: "changemakers"
          },
          {
            link: "#",
            title: "title",
            type: "news"
          }
        );
      }
      Omnisearch.completeForm(data);
    },
    error: function(err) {
      //console.log("hata", err);
      Omnisearch.completeForm(null);
    }
  });
};

window.filterChangeMakers = function(formData) {
  //console.log(formData);

  // örnek formData
  // "query" ve/veya "theme" ve/veya "city" ve/veya "season" alanları boş geliyor ise onlarla ilgili bir seçim yapılmamış demektir.
  // range -> sonuçlar arasından hangi aralıktaki itemların dönmesi gerektiğini belirtiyor.

  /* var formData = {
    range: "0-9",
    sort: "asc",
    query: "anahtar kelime",
    theme: theme_id,
    city: city_id,
    season: season_id
  }; */

  //veya

  /* var formData = {
    range: "9-18",
    sort: "asc",
    query: "anahtar kelime",
    theme: theme_id,
    city: city_id,
    season: season_id
  }; */

  //veya

  /* var formData = {
    range: "0-6",
    random: true
  }; */

  $.ajax({
    url: "https://jsonplaceholder.typicode.com/posts",
    type: "GET",
    dataType: "JSON",
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    },
    success: function(data) {
      //console.log(data);

      //item sayısı request->range farkından büyük ise  "hasMore" true dönmeli
      //örn. range "9-18" fakat bulunan item sayısı 10 veya daha fazla, o zaman "hasMore" true dönmeli
      //örn. range "9-18" fakat bulunan item sayısı 9 veya daha az, o zaman "hasMore" false dönmeli
      var data = {
        hasMore: true,
        items: [
          {
            title: "title",
            text: "text",
            theme: "theme",
            image: "https://source.unsplash.com/random",
            link: "#"
          }
        ]
      };
      CmMasonry.completeForm(data);
    },
    error: function(err) {
      //console.log("hata", err);
      CmMasonry.completeForm(null);
    }
  });
};

window.filterNews = function(formData) {
  //console.log(formData);

  // örnek formData
  // range -> sonuçlar arasından hangi aralıktaki itemların dönmesi gerektiğini belirtiyor.

  /* var formData = {
    range: "0-9",
    sort: "asc",
    query: "anahtar kelime"
  }; */

  //veya

  /* var formData = {
    range: "9-18",
    sort: "asc",
    query: "anahtar kelime"
  }; */

  $.ajax({
    url: "https://jsonplaceholder.typicode.com/posts",
    type: "GET",
    dataType: "JSON",
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    },
    success: function(data) {
      //console.log(data);

      //item sayısı request->range farkından büyük ise  "hasMore" true dönmeli
      //örn. range "9-18" fakat bulunan item sayısı 10 veya daha fazla, o zaman "hasMore" true dönmeli
      //örn. range "9-18" fakat bulunan item sayısı 9 veya daha az, o zaman "hasMore" false dönmeli
      var data = {
        hasMore: true,
        items: [
          {
            title: "title",
            text: "text",
            date: "date",
            image: "https://source.unsplash.com/random",
            link: "#"
          }
        ]
      };
      NMasonry.completeForm(data);
    },
    error: function(err) {
      //console.log("hata", err);
      NMasonry.completeForm(null);
    }
  });
};
